import InvestStrategiesPageNew from './InvestStrategiesPageNew';

export default InvestStrategiesPageNew;
